import { config } from '../../../config/config';

import { isInApp } from './is-app';

/**
 * Requests the authentication details from the sportnco native app if we are running in the native app.
 */
export async function getAppAuthentication() {
    const isNativeApp = isInApp();
    const urlParams = new URLSearchParams(window.location.search);
    const sourceParam = urlParams.get('source');
    const currentUrl = window.location.href;

    if (
        !(
            (isNativeApp && config.SPORTNCO_NATIVE_APP.IS_ENABLED) ||
            (sourceParam === 'nativeapp' && config.SPORTNCO_NATIVE_APP.IS_ENABLED)
        )
    ) {
        return;
    }

    // Check if "/auth" is present in the URL
    if (
        currentUrl.indexOf('/auth') !== -1 ||
        currentUrl.indexOf('/documents') !== -1 ||
        currentUrl.indexOf('/app/footer') !== -1
    ) {
        console.log("The URL contains '/auth' or /documents or /app/footer.");
        return;
    } else {
        console.log("The URL does not contain '/auth' /auth' or /documents or /app/footer.");
    }

    return new Promise<void>((resolve) => {
        const messageHandler = (message: MessageEvent) => {
            if (!message.data || message.data.message !== 'sportnco_send_tokens') {
                try {
                    window.parent.postMessage(
                        { message: 'external_tokens_iframe_ready' },
                        config.SPORT_ENDPOINT,
                    );
                } catch (error) {
                    console.error('An error occurred while executing postMessage:', error);
                }
                return;
            }

            try {
                const eventData = message.data.args;

                if (!eventData) {
                    console.log(eventData, 'There is no eventData');
                    return;
                }

                const access_token = eventData.auth_token;
                const refresh_token = eventData.refresh_token;
                const id_token = eventData.id_token;

                if (!access_token || !refresh_token || !id_token) {
                    console.log(access_token, refresh_token, id_token, 'No tokens');
                    return;
                }

                // Decode id_token, these are not validated til we send them to the server
                // Presume these contain unsanitized data
                const profile = JSON.parse(atob(id_token.split('.')[1]));
                const accessToken = JSON.parse(atob(access_token.split('.')[1]));

                const session_state = accessToken.sid;

                const storedAuthenticationState = {
                    access_token,
                    refresh_token,
                    id_token,
                    profile,
                    session_state,
                    expires_at: accessToken.exp,
                    token_type: accessToken.typ,
                    scope: accessToken.scope,
                };

                const key = `oidc.user:${config.AUTH_ENDPOINT}realms/${config.KEYCLOAK_REALM}:${config.SPORTNCO_NATIVE_APP.KEYCLOAK_CLIENT_ID}`;
                localStorage.setItem(key, JSON.stringify(storedAuthenticationState));
            } catch (e) {
                console.error('Could not restore from app state', e);
            } finally {
                window.removeEventListener('message', messageHandler);
                resolve();
            }
        };

        window.addEventListener('message', messageHandler);

        try {
            window.parent.postMessage(
                { message: 'external_tokens_iframe_ready' },
                config.SPORT_ENDPOINT,
            );
        } catch (error) {
            console.error('An error occurred while executing postMessage:', error);
        }
    });
}
